import {remCalc} from '_themeUtils'

const shareBox = {
    ShareBox: {
        baseStyle: () => ({
            content: {
                borderRadius: 0,
            },
            wrapper: {
                py: 'spacing.6',
                px: 'spacing.4',
            },
            header: {
                justify: 'space-between',
                mb: 'spacing.7',
            },
            title: {
                textStyle: 'paragraphXs',
                letterSpacing: remCalc(3),
                textTransform: 'uppercase',
                fontWeight: 400,
            },
            socials: {
                justify: 'space-between',
                mb: 'spacing.4',
            },
            shareButton: {
                justify: 'center',
                cursor: 'pointer',
                mb: 'spacing.4',
                mx: 'auto',
            },
            shareLabel: {
                borderBottom: `${remCalc(1)} solid`,
                textStyle: 'paragraphSm',
                fontWeight: 400,
                letterSpacing: remCalc(1),
            },
            weChatPopoverContent: {
                w: 'fit-content',
            },
            weChatPopoverBody: {
                p: 'spacing.4',
            },
            mobileWrapper: {
                w: 'full',
                h: 'fit-content',
                bg: 'color.background.white',
                zIndex: 'toast',
                overflowY: 'auto',
                px: 'spacing.4',
                py: 'spacing.6',
                position: 'fixed',
                bottom: 0,
                left: 0,
                maxH: 'full',
            },
            mobileSocials: {
                align: 'flex-start',
                spacing: 0,
            },
            mobileSocial: {
                spacing: 'spacing.10',
                py: 'spacing.4',
                align: 'center',
                w: 'full',
            },
            mobileSocialName: {
                textStyle: 'paragraphMd',
                fontWeight: 400,
            },
            mobileWeChatOverlay: {
                position: 'absolute',
                cursor: 'pointer',
                top: 0,
                left: 0,
                w: 'full',
                h: 'full',
                bg: `rgba(0, 0, 0, .2)`,
            },
            mobileWeChatImageWrapper: {
                position: 'absolute',
                top: '40%',
                left: '50%',
                transform: 'translateX(-50%)',
                bg: 'color.background.white',
                p: 'spacing.4',
                borderRadius: remCalc(5),
                border: `${remCalc(1)} solid`,
                borderColor: 'color.border.grey.300',
            },
        }),
    },
}

export default shareBox
